import { render, staticRenderFns } from "./honors.vue?vue&type=template&id=5bb1c955&scoped=true"
import script from "./honors.vue?vue&type=script&lang=js"
export * from "./honors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb1c955",
  null
  
)

export default component.exports